import React from "react";
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";
import TitansNavbar from "../Components/TitansNavbar";
import TitansHero from "../Components/TitansHero";
import TitansHousingVideo from "../Components/TitansHousingVideo";
function TitansHousing() {
  return (
    <>
      <Navbar2 />
      <TitansHero />
      <TitansNavbar />
        {/* Housing & Facilities */}
        <div className="container-fluid">
            <div className='titansTitle text-center pt-5 pb-3'>
              Housing &amp; Facilities
            </div>
            <div className="row">
              <div className="col-12 lead ps-5 pe-5 pb-3">
                  ADS will provide housing, daily transportation,
                  and three meals a day for all eligible athletes.
                  Players will also have access to a weight room,
                  film room, recovery lab, and multiple state-of-the-art
                  indoor courts.
                </div>
                <div className="col-12 pb-5">
                  <TitansHousingVideo />
              </div>
            </div>
        </div>
      <Footer />
    </>
);
}

export default TitansHousing;
